import React from 'react';
import ReactDOM from 'react-dom/client';
// Self-hosted fonts: bundled into the build so the dashboard works air-gapped.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
import '@fontsource/inter/900.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import '@fontsource/noto-sans-arabic/400.css';
import '@fontsource/noto-sans-arabic/500.css';
import '@fontsource/noto-sans-arabic/600.css';
import '@fontsource/noto-sans-arabic/700.css';
import './i18n';
import { LocaleProvider } from './i18n/LocaleProvider';
import './index.css';
import App from './App';
import { installChangeConfirmation, ChangeConfirmHost } from './lib/confirmChanges';

installChangeConfirmation();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <LocaleProvider>
      <App />
      <ChangeConfirmHost />
    </LocaleProvider>
  </React.StrictMode>
);
